export default __webpack_public_path__ + "static/media/No_data_image.26274436.png";